import mathHelper from "../Helpers/mathHelper";
import React from "react";
import RateMicroGraph from "../Elements/RateMicroGraph";

export default class PlanningDetailsItem {
  constructor(item) {
    this.PlanningDetailId = item.planningDetailId;
    this.PricingId = item.pricingId;
    this.PricingDetailId = item.pricingDetailId;
    this.OpportunityId = item.opportunityId;
    this.CreatedOn = item.createdOn;
    this.FieldworkOrderNumber = item.fieldworkOrderNumber;
    this.StartDate = item.startDate;
    this.EndDate = item.endDate;
    this.NumberOfPlannedAssignments = item.numberOfPlannedAssignments;
    this.NumberOfContractedAssignments = item.numberOfContractedAssignments;
    this.OwningOfficeRevenueContracted = item.owningOfficeRevenueContracted;
    this.FieldworkOfficeRevenueContracted = item.fieldworkOfficeRevenueContracted;
    this.FieldworkOfficeCurrency = item.fieldWorkOfficeCurrency;
    this.OwningOfficeCurrency = item.owningOfficeCurrency;
    this.ClientName = item.clientName;
    this.OpportunityName = item.opportunityName;
    this.ServiceName = item.serviceName;
    this.PricingDetailName = item.pricingDetailName;
    this.OpportunityStatuscode = item.opportunityStatuscode;
    this.PlanningDetailStatusCompleted = item.planningDetailStatusCompleted;
    this.CountryId = item.countryId;
    this.CountryName = item.countryName;
    this.ServiceId = item.serviceId;
    this.ClientId = item.clientId;
    this.ClientOwner = item.clientOwner;
    this.EvalBonusPerCycle = item.evalBonusPerCycle;
    this.Status = item.status;
    this.TargetAssignmentRate1 = item.targetAssignmentRate1;
    this.TargetAssignmentRate2 = item.targetAssignmentRate2;
    this.TargetAssignmentRate3 = item.targetAssignmentRate3;
    this.TargetAssignmentRate4 = item.targetAssignmentRate4;
    this.TargetCompletionRate1 = item.targetCompletionRate1;
    this.TargetCompletionRate2 = item.targetCompletionRate2;
    this.TargetCompletionRate3 = item.targetCompletionRate3;
    this.TargetCompletionRate4 = item.targetCompletionRate4;

    this.NumberOfAssignmentsAll = item.numberOfAssignmentsAll; //Number of Assigned Assignments
    this.NumberOfAssignmentsSelfAssigned = item.numberOfAssignmentsSelfAssigned;
    this.NumberOfAssignmentsCompleted = item.numberOfAssignmentsCompleted;
    this.NumberOfAssignmentsFinalized = item.numberOfAssignmentsFinalized;
    this.NumberOfAssignmentsExcluded = item.numberOfAssignmentsExcluded;
    this.NumberOfAssignmentsInvoiced = item.numberOfAssignmentsInvoiced;
    this.NumberOfAssignmentsExcludedEx = item.numberOfAssignmentsExcludedEx;
    this.NumberOfAssignmentsExcludedPS = item.numberOfAssignmentsExcludedPS;
    this.NumberOfAssignmentsExcludedBC = item.numberOfAssignmentsExcludedBC;
    this.OfficeName = item.officeName;
    this.PricingOwningOfficeFeePerEval = item.pricingOwningOfficeFeePerEval;
    this.PricingFieldworkOfficeFeePerEval = item.pricingFieldworkOfficeFeePerEval;
    this.EvalFeePerEval = item.evalFeePerEval;
    this.PricingDetailEditorCostPerEval = item.pricingDetailEditorCostPerEval;
    this.ActualEvaluatorFee = item.actualEvaluatorFee;
    this.ActualEvaluatorFeePerAssignment = item.actualEvaluatorFeePerAssignment;

    this.NumberOfAssignmentsOpen = item.numberOfAssignmentsOpen;
    this.NumberOfAssignmentsNew = item.numberOfAssignmentsNew;
    this.NumberOfAssignmentsIncomplete = item.numberOfAssignmentsIncomplete;
    this.NumberOfAssignmentsApolloCompleted = item.numberOfAssignmentsApolloCompleted;
    this.NumberOfAssignmentsCollaboration = item.numberOfAssignmentsCollaboration;
    this.NumberOfAssignmentsHoldA = item.numberOfAssignmentsHoldA;
    this.NumberOfAssignmentsHoldB = item.numberOfAssignmentsHoldB;
    this.NumberOfAssignmentsReviewed = item.numberOfAssignmentsReviewed;
    this.NumberOfAssignmentsApolloFinalized = item.numberOfAssignmentsApolloFinalized;
    this.NumberOfAssignmentsEmailed = item.numberOfAssignmentsEmailed;
    this.NumberOfAssignmentsClientFinalized = item.numberOfAssignmentsClientFinalized;
    this.NumberOfAssignmentsLocked = item.numberOfAssignmentsLocked;

    this.ServiceName = item.serviceName;

    this.TotalContractedFeeAmount = this.EvalFeePerEval * this.NumberOfContractedAssignments;
    this.TotalPlannedFeeAmount = this.EvalFeePerEval * this.NumberOfPlannedAssignments;

    this.TotalPlannedBonusAmount = (this.EvalBonusPerCycle / this.NumberOfContractedAssignments) * this.NumberOfPlannedAssignments;
    this.PercentageOfContractedEvaluatorFee = mathHelper.PercentageText(this.EvalFeePerEval + this.EvalBonusPerCycle / this.NumberOfContractedAssignments, this.PricingFieldworkOfficeFeePerEval);
    this.PlannedShopperFeePerAssignedAssignments = (this.EvalFeePerEval + this.EvalBonusPerCycle / this.NumberOfContractedAssignments) * this.NumberOfAssignmentsAll;

    this.TotalContractedEvaluatorFeePlusBonus = this.TotalContractedFeeAmount + this.EvalBonusPerCycle;
    this.TotalContractedEvaluatorFeePerAssignmentInclBonus = this.EvalFeePerEval + this.EvalBonusPerCycle / this.NumberOfContractedAssignments;
    this.TotalPlannedEvaluatorFeePlusBonus = this.TotalPlannedFeeAmount + this.TotalPlannedBonusAmount;
    this.TotalPlannedEvaluatorFeePerAssignment = this.NumberOfPlannedAssignments === 0 ? 0 : this.EvalFeePerEval + this.TotalPlannedBonusAmount / this.NumberOfPlannedAssignments;

    this.PlannedRevenueOwningOffice = this.NumberOfPlannedAssignments * this.PricingOwningOfficeFeePerEval;
    this.InvoicedRevenueOwningOffice = this.NumberOfAssignmentsInvoiced * this.PricingOwningOfficeFeePerEval;
    this.PlannedRevenueFieldworkOffice = this.NumberOfPlannedAssignments * this.PricingFieldworkOfficeFeePerEval;
    this.InvoicedRevenueFieldworkOffice = this.NumberOfAssignmentsInvoiced * this.PricingFieldworkOfficeFeePerEval;
    this.RealizedRevenueFieldworkOffice = (this.NumberOfAssignmentsExcludedBC + this.NumberOfAssignmentsFinalized) * this.PricingFieldworkOfficeFeePerEval;

    this.PercentageOfActualEvaluatorFee = mathHelper.PercentageText(this.ActualEvaluatorFeePerAssignment, this.PricingFieldworkOfficeFeePerEval);

    this.PercentageOfAssignedAssignments = mathHelper.PercentageText(this.NumberOfAssignmentsAll, this.NumberOfPlannedAssignments);
    this.PercentageOfCompletedAssignments = mathHelper.PercentageText(this.NumberOfAssignmentsCompleted, this.NumberOfPlannedAssignments);
    this.PercentageOfFinalizedAssignments = mathHelper.PercentageText(this.NumberOfAssignmentsFinalized, this.NumberOfPlannedAssignments);
    this.PercentageOfExcludedAssignments = mathHelper.PercentageText(this.NumberOfAssignmentsExcluded, this.NumberOfPlannedAssignments);
    this.PercentageOfInvoicedAssignments = mathHelper.PercentageText(this.NumberOfAssignmentsInvoiced, this.NumberOfPlannedAssignments);
    this.PercentageOfSelfAssignedAssignments = mathHelper.PercentageText(this.NumberOfAssignmentsSelfAssigned, this.NumberOfPlannedAssignments);

    this.Selected = true;
  }

  static IsThisFieldEditable(fieldname) {
    return ["StartDate", "EndDate", "NumberOfPlannedAssignments"].includes(fieldname);
  }

  static IsThisFieldADate(fieldname) {
    this.DateFields().includes(fieldname);
  }

  static DateFields = ["CreatedOn", "StartDate", "EndDate"];

  static FieldsToShowInListTable() {
    return [];
  }

  static NameOfTheIdField() {
    return "PlanningDetailId";
  }
  static BoolFields = [];

  //MoneyFields_FieldworkOffice()
  static MoneyFieldsSecondary = [
    "FieldworkOfficeRevenueContracted",
    "PricingFieldworkOfficeFeePerEval",
    "PricingFeePerEval",
    "EvalFeePerEval",
    "PricingDetailEditorCostPerEval",
    "PlannedRevenueFieldworkOffice",
    "InvoicedRevenueFieldworkOffice",
    "EvalBonusPerCycle",
    "TotalContractedFeeAmount",
    "TotalPlannedBonusAmount",
    "PlannedShopperFeePerAssignedAssignments",
    "ActualEvaluatorFee",
    "TotalContractedEvaluatorFeePlusBonus",
    "TotalContractedEvaluatorFeePerAssignmentInclBonus",
    "TotalPlannedEvaluatorFeePlusBonus",
    "TotalPlannedEvaluatorFeePerAssignment",
    "ActualEvaluatorFee",
    "ActualEvaluatorFeePerAssignment",
    "RealizedRevenueFieldworkOffice",
  ];

  static CurrencySecondary() {
    return "FieldworkOfficeCurrency";
  }

  // MoneyFields_OwningOffice
  static MoneyFields = ["OwningOfficeRevenueContracted", "PricingOwningOfficeFeePerEval", "PlannedRevenueOwningOffice", "RealizedRevenueOwningOffice", "InvoicedRevenueOwningOffice"];

  static Currency() {
    return "OwningOfficeCurrency";
  }

  static GenerateMicroGraph(item) {
    if (item.NumberOfPlannedAssignments <= 0) {
      return null;
    }
    const numbers = [
      //Not assigned
      item.NumberOfPlannedAssignments - item.NumberOfAssignmentsAll,
      //Assigned but not completed
      item.NumberOfAssignmentsAll - item.NumberOfAssignmentsCompleted,
      //completed but not finalized
      item.NumberOfAssignmentsCompleted - item.NumberOfAssignmentsFinalized,
      //Finalized but not invoiced
      item.NumberOfAssignmentsFinalized - item.NumberOfAssignmentsInvoiced,
      //Invoiced
      item.NumberOfAssignmentsInvoiced,
      //Excluded
      item.NumberOfAssignmentsExcluded,
    ];
    const colors = ['Grey', 'Orange', 'Yellow', 'LightGreen', 'Green', 'Red'];
    const names = ['Planned', 'Assigned', 'Completed', 'Finalized', 'Invoiced', 'Excluded'];
    return (
      <RateMicroGraph
        numbers={numbers}
        colors={colors}
        names={names}
      />
    );
  }

  static uniquePageIdForBlockCookies = "planningdfro";
  static BlocksInDataTable = [
    { name: "info", label: "Info", checkedDefault: false, bgcolor: "#DCDCDC" },
    { name: "graph", label: "Graph", checkedDefault: false, bgcolor: "" },
    { name: "percentages", label: "Percentages", checkedDefault: true, bgcolor: "#FFFF00" },
    { name: "revenues", label: "Revenues", checkedDefault: false, bgcolor: "#4CC552" },
    { name: "fees", label: "Fees", checkedDefault: false, bgcolor: "#EE9A4D" },
    { name: "assignments", label: "Assignments", checkedDefault: false, bgcolor: "#6698FF" },
  ];

  static FieldsToShowInDataTable() {
    return [
      { label: "Id", orderById: "PlanningDetailId", data: "PlanningDetailId", block: "info" },
      { label: "Client", orderById: "ClientName", data: "ClientName" },
      { label: "Service", orderById: "Service", data: "ServiceName" },
      { label: "Country", orderById: "CountryName", data: "CountryName" },
      { label: "StartDate", orderById: "StartDate", data: "StartDate" },
      { label: "EndDate", orderById: "EndDate", data: "EndDate" },
      { label: "Fw Office", orderById: "Office", data: "OfficeName", block: "info" },
      { label: "Account Manager", orderById: "AccountManager", data: (item) => (item.ClientOwner === "You-Know-Who" ? "-" : item.ClientOwner), block: "info" },
      { label: "FW Period", orderById: "fwperiod", data: "FieldworkOrderNumber", block: "info" },
      { label: "Status", orderById: "Status", data: "Status", block: "info" },

      { label: "Graph", orderById: "", data: PlanningDetailsItem.GenerateMicroGraph, block: "graph" },

      { label: "Scheduled %", orderById: "scheduled", data: "PercentageOfAssignedAssignments", block: "percentages" },
      { label: "Completed %", orderById: "completed", data: "PercentageOfCompletedAssignments", block: "percentages" },
      { label: "Finalized %", orderById: "finalized", data: "PercentageOfFinalizedAssignments", block: "percentages" },
      { label: "Invoiced %", orderById: "invoiced", data: "PercentageOfInvoicedAssignments", block: "percentages" },
      { label: "Excluded %", orderById: "excluded", data: "PercentageOfExcludedAssignments", block: "percentages" },
      { label: "Self-assigned %", orderById: "selfassigned", data: "PercentageOfSelfAssignedAssignments", block: "percentages" },

      { label: "Planned Revenue", orderById: "plannedrevenue", data: "PlannedRevenueFieldworkOffice", block: "revenues" },
      { label: "Realized Revenue", orderById: "realizedrevenue", data: "RealizedRevenueFieldworkOffice", block: "revenues" },
      { label: "Invoiced Revenue", orderById: "invoicedrevenue", data: "InvoicedRevenueFieldworkOffice", block: "revenues" },

      { label: "Contracted Ev. Fee %", orderById: "PercentageOfContractedEvaluatorFee", data: "PercentageOfContractedEvaluatorFee", block: "fees" },
      { label: "Actual Evaluator Fee %", orderById: "PercentageOfActualEvaluatorFee", data: "PercentageOfActualEvaluatorFee", block: "fees" },

      { label: "Required (Planned shopcount)", orderById: "NumberOfPlannedAssignments", data: "NumberOfPlannedAssignments", block: "assignments" },
      { label: "Open / Not yet scheduled", orderById: "NumberOfAssignmentsOpen", data: "NumberOfAssignmentsOpen", block: "assignments" },
      { label: "New", orderById: "NumberOfAssignmentsNew", data: "NumberOfAssignmentsNew", block: "assignments" },
      { label: "Incomplete", orderById: "NumberOfAssignmentsIncomplete", data: "NumberOfAssignmentsIncomplete", block: "assignments" },
      { label: "Completed", orderById: "NumberOfAssignmentsApolloCompleted", data: "NumberOfAssignmentsApolloCompleted", block: "assignments" },
      { label: "Collaboration", orderById: "NumberOfAssignmentsCollaboration", data: "NumberOfAssignmentsCollaboration", block: "assignments" },
      { label: "Hold A", orderById: "NumberOfAssignmentsHoldA", data: "NumberOfAssignmentsHoldA", block: "assignments" },
      { label: "Hold B", orderById: "NumberOfAssignmentsHoldB", data: "NumberOfAssignmentsHoldB", block: "assignments" },
      { label: "Reviewed", orderById: "NumberOfAssignmentsReviewed", data: "NumberOfAssignmentsReviewed", block: "assignments" },
      { label: "Finalized", orderById: "NumberOfAssignmentsApolloFinalized", data: "NumberOfAssignmentsApolloFinalized", block: "assignments" },
      { label: "Emailed", orderById: "NumberOfAssignmentsEmailed", data: "NumberOfAssignmentsEmailed", block: "assignments" },
      { label: "Client Finalized", orderById: "NumberOfAssignmentsClientFinalized", data: "NumberOfAssignmentsClientFinalized", block: "assignments" },
      { label: "Locked", orderById: "NumberOfAssignmentsLocked", data: "NumberOfAssignmentsLocked", block: "assignments" },
      { label: "Excluded BC", orderById: "NumberOfAssignmentsExcludedBC", data: "NumberOfAssignmentsExcludedBC", block: "assignments" },
      { label: "Excluded PS", orderById: "NumberOfAssignmentsExcludedPS", data: "NumberOfAssignmentsExcludedPS", block: "assignments" },
      { label: "Excluded Excluded", orderById: "NumberOfAssignmentsExcludedEx", data: "NumberOfAssignmentsExcludedEx", block: "assignments" },
    ];
  }
}
